import firebase from 'firebase/app';
import 'firebase/auth';
import actions from '../constants';

const logoff = dispatch => {
  dispatch({
    type: actions.LOGOFF_START,
  });

  return firebase.auth().signOut();
};

export default logoff;



// WEBPACK FOOTER //
// ./src/modules/auth/actions/logoff.js